/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";

import Typography from "@mui/material/Typography";

import { Colors } from "@dotnet/telematics-design-system";

import RectangleLoader from "../../../../../../../shared/components/loaders/RectangleLoader";
import { useStyles as sharedStyles } from "../../../../../../../shared/styles/sharedStyles";
import { useStyles } from "../styles";

interface AccordionDetailsCardTitleAreaProps {
  displayLoader: boolean;
  title: string;
  colors: Colors;
  titleInlineAddition?: string;
  quickAction?: ReactNode;
  titleInlineIcon?: ReactNode;
}

const AccordionDetailsCardTitleArea = ({
  displayLoader,
  title,
  colors,
  titleInlineAddition,
  quickAction,
  titleInlineIcon
}: AccordionDetailsCardTitleAreaProps) => {
  const {
    acordionDetailsCardTitleContainer,
    acordionDetailsCardTitle,
    titleInlineIconDiv
  } = useStyles({});
  const { flexbox } = sharedStyles();

  return (
    <div
      css={css(acordionDetailsCardTitleContainer)}
      data-testid="accordion-details-card-title"
    >
      {displayLoader ? (
        <RectangleLoader
          height="16px"
          width="216px"
          testId={`accordion-details-card-title-loader-${title}`}
        />
      ) : (
        <div css={css(acordionDetailsCardTitle)}>
          <div css={css(flexbox)}>
            <Typography variant="body2SemiBold">{title}</Typography>
            {/* empty space: */}
            <Typography variant="body2Medium">&nbsp;</Typography>
            {titleInlineAddition && (
              <>
                <Typography
                  variant="body2Medium"
                  css={css({ color: colors.textPlaceholder })}
                >
                  {titleInlineAddition}
                </Typography>
                <div css={css(titleInlineIconDiv)}>{titleInlineIcon}</div>
              </>
            )}
          </div>
          {quickAction}
        </div>
      )}
    </div>
  );
};

export default AccordionDetailsCardTitleArea;
